import React from "react";
import classes from "./LoginAlert.module.css";

const LoginAlert = (props) => {
	return (
		<div
			style={props.style}
			className={classes.container}
			onClick={props.onClick}
		>
			<div>
				<p>Sign up to receive fire alerts</p>
			</div>
			
			<div className={classes.iconContainer}>
				<i className={`fa fa-user ${classes.userIcon}`}/>
				<i className={`fa fa-calendar-o ${classes.calendarIcon}`} aria-hidden="true"></i>
			</div>
		</div>
	);
};

export default LoginAlert;
